export const SIDEBAR_SECTIONS = {
  TUTORIALS: 'tutorials',
  NEWS: 'news',
  HELP: 'help',
  SUPPORT: 'support',
  FEEDBACK: 'feedback',
  DEMO: 'demo',
  MOBILE: 'mobile',
  TRANSLATION_ERROR: 'translation_error',
};

export const SIDEBAR_TOP_NAV_CONFIG = [
  {
    id: SIDEBAR_SECTIONS.TUTORIALS,
    icon: 'tutorial',
    iconType: 'regular',
    label: 'lc_sidebar_tutorials',
    showMarker: false,
  },
  {
    id: SIDEBAR_SECTIONS.NEWS,
    icon: 'news',
    iconType: 'regular',
    label: 'lc_sidebar_whats_new',
  },
  {
    id: SIDEBAR_SECTIONS.FEEDBACK,
    icon: 'feedback',
    iconType: 'regular',
    label: 'lc_sidebar_feedback',
    showMarker: false,
  },
];

export const SIDEBAR_UTILITY_NAV_CONFIG = [
  {
    id: SIDEBAR_SECTIONS.MOBILE,
    icon: 'mobile',
    iconType: 'regular',
    label: 'lc_sidebar_mobile_apps',
  },
];
